import {
  faGear,
  faUser,
  faUsers,
  faTelescope,
  faCircleQuestion,
  faMegaphone,
} from "@fortawesome/pro-light-svg-icons";
import { SideBarDataType } from "./sideBarDataTypes.ts";

export const sideBarNavData: SideBarDataType = [
  {
    id: "personas",
    link: "/personas",
    title: "personas",
    icon: faUser,
    children: [],
  },
  {
    id: "manage_campaigns",
    link: "/campaigns",
    title: "manage campaigns",
    icon: faMegaphone,
    children: [],
  },
  {
    id: "communities_creators",
    link: "",
    title: "communities & creators",
    icon: faTelescope,
    children: [
      {
        id: "communities_creators_1",
        title: "",
        links: [
          {
            id: "communities_creators_1_discover_communities",
            link: "/discover-communities",
            title: "discover communities",
          },
          {
            id: "communities_creators_1_creators",
            link: "/creators",
            title: "manage creators",
          },

          {
            id: "communities_creators_1_creator-briefs",
            link: "/creator-briefs",
            title: "creator briefs",
          },
        ],
      },
    ],
  },
  {
    id: "settings",
    link: "",
    title: "settings",
    icon: faGear,
    children: [
      {
        id: "settings_1",
        title: "company settings",
        links: [
          {
            id: "settings_1_company-settings",
            link: "/company-settings",
            title: "company",
          },
          {
            id: "settings_1_subscription-settings",
            link: "/subscription-settings",
            title: "subscription",
          },
        ],
      },
      {
        id: "settings_2",
        title: "personal settings",
        links: [
          {
            id: "settings_2_profile-settings",
            link: "/profile-settings",
            title: "profile",
          },
          {
            id: "settings_2_security-settings",
            link: "/security-settings",
            title: "security",
          },
        ],
      },
    ],
  },
  {
    id: "help",
    link: "",
    title: "help",
    icon: faCircleQuestion,
    children: [
      {
        id: "help_1",
        title: "",
        links: [
          {
            id: "help_1_contact-us",
            link: "/contact-us",
            title: "contact us",
          },
        ],
      },
    ],
  },
];

/**
 * Returns the navigation data based on user permissions.
 * If canManagePlatform is true, it transforms the "personas" object into the nested "audiences" structure.
 */
export const getNavigationData = (
  canManagePlatform: boolean,
  noBrand: boolean,
): SideBarDataType => {
  let data = sideBarNavData.map((item) => {
    if (canManagePlatform && item.id === "personas") {
      return {
        ...item,
        id: "audiences",
        title: "audiences",
        icon: faUsers,
        link: "",
        children: [
          {
            id: "audiences_groups",
            title: "",
            links: [
              {
                id: "audiences_personas",
                link: "/personas",
                title: "personas",
              },
              {
                id: "audiences_generations",
                link: "/generations",
                title: "generations",
              },
            ],
          },
        ],
      };
    }
    return item;
  });

  if (noBrand) {
    data = data.filter((item) => item.id === "settings" || item.id === "help");
  }

  return data;
};
